module.exports = flarum.core.compat['components/PostPreview'];